import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary/index.tsx";
import { pdfjs } from 'react-pdf';
import "core-js/es/array/flat";


pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';



ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
